import { render } from "./ClassInfo.vue?vue&type=template&id=1ee9de30"
import script from "./ClassInfo.vue?vue&type=script&lang=js"
export * from "./ClassInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__